var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2907_33763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0013 12.5003L6.66797 14.167L10.418 10.417M6.66797 6.66699V4.33366C6.66797 3.40024 6.66797 2.93353 6.84962 2.57701C7.00941 2.2634 7.26438 2.00844 7.57798 1.84865C7.9345 1.66699 8.40121 1.66699 9.33464 1.66699H15.668C16.6014 1.66699 17.0681 1.66699 17.4246 1.84865C17.7382 2.00844 17.9932 2.2634 18.153 2.57701C18.3346 2.93353 18.3346 3.40024 18.3346 4.33366V10.667C18.3346 11.6004 18.3346 12.0671 18.153 12.4236C17.9932 12.7372 17.7382 12.9922 17.4246 13.152C17.0681 13.3337 16.6014 13.3337 15.668 13.3337H13.3346M4.33464 18.3337H10.668C11.6014 18.3337 12.0681 18.3337 12.4246 18.152C12.7382 17.9922 12.9932 17.7372 13.153 17.4236C13.3346 17.0671 13.3346 16.6004 13.3346 15.667V9.33366C13.3346 8.40024 13.3346 7.93353 13.153 7.57701C12.9932 7.2634 12.7382 7.00844 12.4246 6.84865C12.0681 6.66699 11.6014 6.66699 10.668 6.66699H4.33464C3.40121 6.66699 2.9345 6.66699 2.57798 6.84865C2.26438 7.00844 2.00941 7.2634 1.84962 7.57701C1.66797 7.93353 1.66797 8.40024 1.66797 9.33366V15.667C1.66797 16.6004 1.66797 17.0671 1.84962 17.4236C2.00941 17.7372 2.26438 17.9922 2.57798 18.152C2.9345 18.3337 3.40121 18.3337 4.33464 18.3337Z",
    stroke: "#38CB89",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2907_33763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDone);
export default __webpack_public_path__ + "static/media/check-done.7a2f12909db7f61a364629fa64ac5192.svg";
export { ForwardRef as ReactComponent };